import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationSamlUpdateArgs, SamlSettings } from "types/generated";

type FetchSAMLUpdate = { samlUpdate: Pick<SamlSettings, "claimMapping"> };
export const UPDATE_SSO_SAML: TypedDocumentNode<FetchSAMLUpdate, MutationSamlUpdateArgs> = gql`
  mutation SSOUpdateSAML($input: SAMLUpdateInput!) {
    samlUpdate(input: $input) {
      claimMapping {
        entries {
          name
          value
        }
      }
    }
  }
`;
